import { doodBlockConfig } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';
import type { ShopAroundListBodyPreviewShop } from './shop-around-list-body-block.config';

/**
 * Serializable preview VM for `ShopsMapBlockComponent`.
 * `shops: undefined` means loading skeleton.
 */
export type ShopsMapBlockScenarioContent = {
  shops: readonly ShopAroundListBodyPreviewShop[] | undefined;
};

export const SHOPSMAPBLOCK_LEGACY_FIELD_ORDER = [];

const {
  shopsMapBlockDescriptor: _generatedShopsMapBlockDescriptor,
  shopsMapBlockBlocDefinition,
  shopsMapBlockDashboardLayout,
  shopsMapBlockConfig,
  shopsMapBlockResolveConfig,
  shopsMapBlockProperties,
  shopsMapBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Shops map",
    componentType: 'ShopsMapBlockComponent',
    category: 'catalog',
    description: "Shops map.",
    keywords: [],
    hideFromPicker: true,
    allowed_in: ["ShopsMapPage"],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shops-map.tab.content.label",
        fieldsets: [],
      },
    ],
  })
);

export function shopsMapBlockDescriptor(): IBlockDescriptor;
export function shopsMapBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopsMapBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopsMapBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopsMapBlockDescriptor, shopsMapBlockProperties, fieldOrder);
}

export {
  shopsMapBlockBlocDefinition,
  shopsMapBlockDashboardLayout,
  shopsMapBlockProperties,
  shopsMapBlockConfig,
  shopsMapBlockResolveConfig,
  shopsMapBlockDefinitionSetupScenarios,
};

export type ShopsMapBlockConfig = typeof shopsMapBlockConfig;
